import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

import './TopMenu.css';

import { useMtg } from '../../../hook/useMtg';
import { useAuth } from '../../../hook/useAuth';
import { buildClass } from '../../../libs/classes';
import { isNumber } from '../../../libs/helper';
import SimpleInput from '../../../components/SimpleComponents/SimpleInput';
import SimpleButton, { ButtonTypes } from '../../../components/SimpleComponents/SimpleButton';

/**
 * Top menu
 * @component
 */
const TopMenu = () => {
	const [cutoffPriceNan, setCutoffNan] = useState(false);
	const [cutoffPriceValue, setCutoffValue] = useState('');
	const [cutoffPriceChanged, setCutoffChanged] = useState(false);

	const { authenticated, signin, signout } = useAuth();
	const { version, cutoffPrice, setCutoffPrice } = useMtg();

	useEffect(() => {
		setCutoffValue(cutoffPrice);
	}, [cutoffPrice]);

	return (
		<div className="layout-topmenu">
			<div className="wrapper">
				<NavLink end className="logo" title={`MTG Keeper v${version.frontend}`} to="/" />
				<div className="menu-holder">
					<NavLink
						end
						className={({ isActive }) => String(buildClass('menu-item').add(isActive, 'active'))}
						title="Browse all Magic cards"
						to="/sets"
					>
						All cards
					</NavLink>
					<NavLink
						className={({ isActive }) => String(buildClass('menu-item').add(isActive, 'active'))}
						title="Manage your collection"
						to="/collection"
					>
						Collection
					</NavLink>
					{/* <NavLink
                        className={({isActive}) => String(buildClass('menu-item').add(isActive, 'active'))}
                        title="Construct your deck"
                        to="/decks"
                        >Decks</NavLink> */}
				</div>
				<div className="cut-off">
					$
					<SimpleInput
						className={String(buildClass('').add(cutoffPriceNan, 'nan').add(cutoffPriceChanged, 'changed'))}
						title="The price limit below which the price is not taken into account"
						value={String(cutoffPriceValue)}
						onChange={handleChangePrice}
						onKeyDown={handleKeydownPrice}
					/>
				</div>
				<div className="signin">
					{(authenticated && (
						<SimpleButton title="Sign out" type={ButtonTypes.GREY} value="Sign Out" onClick={signout} />
					)) || <SimpleButton title="Sign in" type={ButtonTypes.GREY} value="Sign In" onClick={signin} />}
				</div>
			</div>
		</div>
	);

	function handleChangePrice(event) {
		setCutoffNan(false);
		setCutoffChanged(true);
		setCutoffValue(event.target.value);
	}
	function handleKeydownPrice(event) {
		if (event.key === 'Enter') {
			if (isNumber(cutoffPriceValue)) {
				const cutoffPriceNumber = Number(cutoffPriceValue);
				setCutoffPrice(cutoffPriceNumber);
				setCutoffChanged(false);
			} else {
				setCutoffNan(true);
			}
		}
	}
};

TopMenu.propTypes = {};

export default TopMenu;
